import { FC } from "react";
import { IconProps } from "./types";

export const SocialXCircle: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m17.242 6.27-4.175 4.852 4.54 6.608h-3.339l-3.057-4.45-3.828 4.45h-.99l4.378-5.09-4.377-6.37h3.339l2.895 4.213 3.624-4.213h.99zm-2.509 10.749h1.52L9.259 7.014h-1.52l6.994 10.005z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z"
      fill={fill}
    />
  </svg>
);
